import { API } from "aws-amplify";
import { updateApplication } from "~/graphql/mutations";
import * as APITypes from "~/API";
import { LoaderData } from "~/types";
import { EMPTY_APPLICATION_INFO } from "../getLeaseInfo/getApplicationInfo";

export const editApplication = async (
  payload: APITypes.UpdateApplicationInput
): Promise<LoaderData<APITypes.Application>> => {
  try {
    const response = (await API.graphql({
      query: updateApplication,
      variables: {
        input: payload,
      },
    })) as { data?: APITypes.UpdateApplicationMutation };

    return {
      success: true,
      data: response.data?.updateApplication || EMPTY_APPLICATION_INFO,
    };
  } catch (error) {
    console.error("Error editing lease application", error);
    return {
      success: false,
      data: EMPTY_APPLICATION_INFO,
      error,
    };
  }
};
